// extracted by mini-css-extract-plugin
export default {"root":"app-react-portainer-chat-ChatBot-ChatBot-module__root"};